import React, { useContext, FormEvent } from 'react';

import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form, { IChangeEvent } from '@rjsf/core';
import { RJSFSchema } from '@rjsf/utils';
import validator from "@rjsf/validator-ajv8";
import { Tool } from '../../../../types/entities';
import { DefaultFormDialog  } from "./components/DefaultFormDialog";

export const WorkflowNodeToolConfigure = (props: any) => {
    const context = useContext(WorkflowContext);
    const tool: Tool = context.editingTool;
    if (!tool) {
        return null;
    }
    let formData = undefined;

    if (context.selectedNode !== undefined) {
        let selectedNode = context.selectedNode;
        let toolsConfigurations = selectedNode.data.toolConfiguration;
        if (toolsConfigurations !== undefined) {
            for(const toolConfiguration of toolsConfigurations) {
                if (toolConfiguration.id === tool.id) {
                    formData = toolConfiguration.data;
                    break;
                }
            }
        }
    }

    function handleCloseDialog() {
        context.toggleToolConfigureModal(false);
    }

    const handleFormSubmit = (data: IChangeEvent, event: FormEvent<any>) : void => {
        context.updateToolConfiguration(data.formData, tool.id, tool.operatorToolId);
        handleCloseDialog()
    }

    const formSchema: RJSFSchema = {
        title: '',
        type: 'object',
        required: [],
        properties: JSON.parse(tool.customParameters ?? '')
    }

    return (
        <DefaultFormDialog
            open={ context.toolConfigureModalOpen }
            title={ tool.name + " Configuration"  }
            handleClose={ handleCloseDialog }
        >
            <Form
                validator={validator}
                schema={ formSchema }
                onSubmit={ handleFormSubmit }
                id="workflow-node-create-edit"
                formData={ formData }
            />
        </DefaultFormDialog>
    );

}